import { Injectable } from "@nestjs/common";
import { Repository } from "typeorm";
import { InjectRepository } from "@nestjs/typeorm";
import { StockInEntity } from "../entities/stock-in.entity";
import { NeedleModelEntity } from "../../masters/needle-model/entity/needle-model-entity";
import { NeedleSizes } from "../../needle-sizes/needle-sizes-entity";
import { PointTypesEntity } from "../../point-type/entities/point-type-entity";

@Injectable()
export class StockInRepository extends Repository<StockInEntity> {

    constructor(@InjectRepository(StockInEntity) private stockInRepo: Repository<StockInEntity>
    ) {
        super(stockInRepo.target, stockInRepo.manager, stockInRepo.queryRunner);
    }
 
async getStockInfoByDateRange(startDate: Date, endDate: Date) {
  const query = this.createQueryBuilder('stock')
    .select([
      'stock.id AS id',
      'neMo.needle_model AS needleModel',
      'neSi.needle_sizes AS needleSize',
      'poTy.point_type AS pointType',
      'stock.quantity AS quantity',
      'COALESCE(SUM(stockOut.issued_quantity), 0) AS issuedQuantity'
    ])
    .leftJoin(NeedleModelEntity, 'neMo', 'neMo.id = stock.model_id')
    .leftJoin(NeedleSizes, 'neSi', 'neSi.id = stock.size_id')
    .leftJoin(PointTypesEntity, 'poTy', 'poTy.id = stock.point_type_id')
    .leftJoin('stock.stockOutData', 'stockOut') 
    .groupBy('stock.id, neMo.needle_model, neSi.needle_sizes, poTy.point_type, stock.quantity');

  if (startDate && endDate) {
    query.where('stock.created_at BETWEEN :startDate AND :endDate', { startDate, endDate });
  }

  return query.getRawMany();
}

}